import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { isEmpty } from 'lodash';
import { MyThunkDispatch, RootState } from 'store';

import { getCompanyBilling } from 'actions/companyBilling';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { Company } from 'models/company';
import CompanyBilling from 'screens/components/CompanyBilling';
import { extractErrorMessage } from 'utils/generic';

const CompanyBillingContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const toast = useToast();
  const { t } = useStoreTranslation();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const { accountResult } = useSelector((state: RootState) => state.user);
  const companyId = accountResult ? accountResult.companyId : '';
  const { company, error } = useSelector((state: RootState) => state.companyBilling);

  useEffect(() => {
    if (error) toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(
    () => {
      setLoading(true);
      const getCompany = async () => {
        let companyResult: Company | undefined;
        if (!loading) {
          companyResult = await dispatch(getCompanyBilling(companyId));
        }

        if (
          !isEmpty(companyResult) &&
          (isEmpty(companyResult?.billingInformation) || isEmpty(companyResult?.address))
        ) {
          history.push('/companyBillingEdit', history.location.state);
          return;
        }

        setLoading(false);
      };
      getCompany();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <CompanyBilling isLoading={loading} company={company} />;
};

export default CompanyBillingContainer;
